import React from 'react'
import MaterialSymbol from '../material-symbol'

const Share = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="share" {...props} />
))

Share.displayName = 'Share'

export default Share
